/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit GroupNumber/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2UserCouple from 'DesignSystem/Svgs/Tysiav2UserCouple/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function GroupNumber({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/GroupNumber"
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let assignDetailsNumberValueData = fromData.useDataValue({ viewPath,
context: 'assign_details',
path: 'number',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="GroupNumber.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2UserCouple
  viewPath={`${viewPath}/Tysiav2UserCouple`}
 height={14}
 width={14}
 fill={dtColorsNeutral400}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={10}
 width={130}
 text="Plan / Group Number"
 color={dtColorsNeutral600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXs}
 data="assign_details.number"
 text={assignDetailsNumberValueData}
/>
</div>
{children}
</React.Fragment>)
}